<template lang="pug">
  .module__main
    .module-content__container
      .mb5
        el-button(size="mini" @click="activateAccountAdd") Добавить
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="accounts.list"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(label="Имя" width="150" )
              template(slot-scope="scope")
                .account-name
                  .status__icon
                    el-tooltip(class="item" effect="dark" :content="scope.row.isActive ? 'Токен активен' : 'Токен не активен'" placement="top-start")
                      i.el-icon-success.color-success(v-if="scope.row.isTokenValid")
                      i.el-icon-warning.color-danger(v-else)
                  span.ml5 {{ scope.row.name }}
            el-table-column(prop="client_id" label="ID клиента" width="150" )
            el-table-column(label="Описание" width="300" )
              template(slot-scope="scope")
                .description-edit(v-if="descriptionEditAccountName === scope.row.name")
                  el-input(v-model="descriptionEditAccountText" maxlength="300")
                  .description__btn.color-success
                    i.el-icon-check.color-success(@click="saveAccountDescription")
                  .description__btn.color-danger
                    i.el-icon-close(@click="resetDescriptionEdit")
                .description(v-else)
                  span.mr5 {{ scope.row.description }}
                  i.update__btn.el-icon-edit(v-if="!descriptionEditAccountName" @click="activateDescriptionEdit(scope.row)")
            el-table-column(label="Действия" width="150" )
              template(slot-scope="scope")
                .control-buttons__container
                  .control__btn.mr5
                    el-button(
                      circle
                      icon="el-icon-edit"
                      size="mini"
                      type="primary"
                      @click="startEditAccount()"
                    )
                  .control__btn
                    el-button(circle icon="el-icon-delete" size="mini" type="danger" @click="startDeleteAccount(scope.row.name)")
    el-dialog(
      :visible.sync="isAccountAdding"
      :before-close="resetAccountAdd"
      title="Добавление аккаунта"
      width="30%"
    )
      .dialog__container
        .dialog-input__block
          .dialog-input__title
            span Имя аккаунта
            span.dialog-input__required
          el-input(v-model="addingAccount.name" placeholder="Введите имя")
        .dialog-input__block
          .dialog-input__title Токен
            span.dialog-input__required
          el-input(v-model="addingAccount.token" placeholder="Введите токен")
        .dialog-input__block
          .dialog-input__title Описание аккаунта
          el-input(v-model="addingAccount.description" placeholder="Введите описание")
        .dialog__buttons
          el-tooltip(:disabled="!addAccountValidationError" class="item" effect="dark" :content="addAccountValidationError" placement="top-start")
            el-button(type="success" :disabled="!!addAccountValidationError" @click="startAccountAdd()") Добавить
          el-button(type="danger" @click="resetAccountAdd()") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import instruments from '../../mixins/instruments';
import {
  CREATE_ACCOUNT,
  LOAD_ACCOUNTS_LIST,
  LOAD_ACCOUNTS_NAMES,
  UPDATE_ACCOUNT_DESCRIPTION,
} from '@/store/const/accounts';

export default {
  name: 'SaudiAccounts',
  mixins: [instruments],
  data() {
    return {
      editedAccount: {
        name: '',
        description: '',
        token: '',
      },
      descriptionEditAccountName: '',
      descriptionEditAccountText: '',
      isAccountAdding: false,
      addingAccount: {
        name: '',
        description: '',
        token: '',
      },
    };
  },
  async mounted() {
    await this.loadAccounts();
  },
  computed: {
    ...mapGetters(['loading', 'error']),
    ...mapGetters('accounts', ['accounts', 'accountsNames']),
    isLoading() {
      return this.loading(LOAD_ACCOUNTS_LIST) === 'loading';
    },
    addAccountValidationError() {
      if (!this.addingAccount.name || !this.addingAccount.token) {
        return 'Введите все необходимые данные';
      }
      if (this.accountsNames.includes(this.addingAccount.name)) {
        return 'Аккаунт с указанным именем уже существует';
      }

      return '';
    },
  },
  methods: {
    ...mapActions('accounts', {
      loadAccounts: LOAD_ACCOUNTS_LIST,
      loadAccountsNames: LOAD_ACCOUNTS_NAMES,
      createAccount: CREATE_ACCOUNT,
      updateAccountDescription: UPDATE_ACCOUNT_DESCRIPTION,
    }),
    activateDescriptionEdit(account) {
      this.descriptionEditAccountText = account.description;
      this.descriptionEditAccountName = account.name;
    },
    resetDescriptionEdit() {
      this.descriptionEditAccountText = '';
      this.descriptionEditAccountName = '';
    },
    activateAccountAdd() {
      this.isAccountAdding = true;
    },
    resetAccountAdd() {
      this.isAccountAdding = false;
      this.addingAccount.name = '';
      this.addingAccount.token = '';
      this.addingAccount.description = '';
    },
    async saveAccountDescription() {
      const request = await this.updateAccountDescription({
        name: this.descriptionEditAccountName,
        text: this.descriptionEditAccountText,
      });
      await this.notifyRequestResult({
        request,
        successMessage: 'Описание аккаунта успешно изменено',
        errorMessage: `Ошибка изменения описания аккаунта`,
        methodOnSuccess: () => {
          this.resetDescriptionEdit();
          this.loadAccounts();
        },
      });
    },
    startEditAccount() {
      this.$message.info('Функционал в разработке');
    },
    async startDeleteAccount(name) {
      this.$confirm(`Вы действительно хотите удалить аккаунт ${name}?`, 'Подтверждение удаления')
        .then(async () => {
          const request = await this.deleteAccount(name);
          await this.notifyRequestResult({
            request,
            successMessage: `Аккаунт ${name} удален`,
            errorMessage: `Ошибка удаления аккаунта`,
            methodOnSuccess: () => {
              this.resetDescriptionEdit();
              this.loadAccounts();
            },
          });
        })
        .catch(() => {
          this.$message.info('Удаление аккаунта отменено');
        });
    },
    async startAccountAdd() {
      const request = await this.createAccount(this.addingAccount);
      await this.notifyRequestResult({
        request,
        successMessage: `Аккаунт ${this.addingAccount.name} добавлен`,
        errorMessage: `Ошибка добавления аккаунта`,
        methodOnSuccess: () => {
          this.resetAccountAdd();
          this.loadAccounts();
        },
      });
    },
  },
};
</script>
<style scoped>
.description-edit {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.description__btn {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border: 1px solid;
  border-radius: 6px;
  margin: auto 2px;
  font-weight: bold;
  cursor: pointer;
}

.update__btn {
  padding: 4px;
  cursor: pointer;
  border: 1px solid #989bcf;
  border-radius: 4px;
}

.control-buttons__container {
  display: flex;
  align-items: center;
}

.account-name {
    display: flex;
}
</style>
